import { CacheCategory } from "../constants/lookup.constants";

export abstract class BaseCacheItem {
    getCacheKey(): string {
        return (this.getCategory() + "_" + this.getCacheKeyOverride()).toLowerCase();
    }
    abstract getCacheKeyOverride(): string;
    abstract getCategory(): string;
}

export class LookupValueRequest extends BaseCacheItem {
    public clientLastModifiedDate: Date | string;

    constructor(public lookupValueQuery: string = null, public parameters: string = "") {
        super();
        this.clientLastModifiedDate = new Date();
    }

    getCacheKeyOverride(): string {
        let cacheKey = `${this.lookupValueQuery}`;
        if (this.parameters) {
            cacheKey += "_" + this.parameters;
        }
        return cacheKey;
    }

    getCategory(): string {
        return CacheCategory.lookups;
    }
}

export class LookupValue {
    id: number;
    name: string;
    isActive?: boolean;
    isDefault?: boolean;
    isSelectable?: boolean;
    isSelected?: boolean;
    sequenceNumber?: number;
    guid?: string;
    additionalData?: { [index: string]: any };
    children?: LookupValue[];
    isParentTicked?: boolean;
}

export class LookupValueResponse {
    private _values: LookupValue[] = [];

    get activeValues(): LookupValue[] {
        return this._values.filter(x => x.isActive);
    }
    
    get allValuesIncludingInactive(): LookupValue[] {
        return this._values;
    }

    defaultValue: LookupValue;
    lastModifiedDate: string;
    lookupValueQuery: string;
    parameters: string;

    constructor(response: GetLookupResponse) {
        this._values = response.values;
        this.defaultValue = response.defaultValue;
        this.lastModifiedDate = response.lastModifiedDate;
        this.lookupValueQuery = response.lookupValueQuery;
        this.parameters = response.parameters;
    }
}

export interface GetLookupResponse {
    values: LookupValue[];
    defaultValue: LookupValue;
    lastModifiedDate: string;
    lookupValueQuery: string;
    parameters: string;
}